import './entity-list.scss'

import { defineComponent } from 'vue'

import { Featured, MovementTypes } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { CREATE_CONTAINER_TOPIC, CREATE_MOVEMENT_TOPIC, CREATE_SIMPLE_MOVEMENT_TOPIC } from '../../../busTopics'
import { CreateMovementModal } from '../../component/create-movement-modal'
import { CreateContainerModal } from '../../component/create-container-modal'

export const EntityList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sCreateMovementModal: CreateMovementModal,
        sCreateContainerModal: CreateContainerModal
    },
    props: ['entityDataStore', 'entityFeaturedList', 'entityHistory', 'targetRouteName'],
    template: require('./entity-list.html'),
    data() {
        return {
            featureds: [] as Array<Featured | null>,
            items: [] as Featured[],
        }
    },
    created() {
        this.subscribeToBus(CREATE_MOVEMENT_TOPIC, this.onCreateMovement.bind(this, MovementTypes.COMPLEX));
        this.subscribeToBus(CREATE_SIMPLE_MOVEMENT_TOPIC, this.onCreateMovement.bind(this, MovementTypes.SIMPLE))
        this.subscribeToBus(CREATE_CONTAINER_TOPIC, this.onCreateContainer.bind(this))
    },
    methods: {
        onCreateMovement(movementType = MovementTypes.COMPLEX) {
            (this.$refs.createMovementModal as InstanceType<typeof CreateMovementModal>).open(movementType);
        },

        onCreateContainer() {
            (this.$refs.createContainerModal as InstanceType<typeof CreateContainerModal>).open()
        },
    },
})
